import Api from '@/services/Api'

export default {
  issueTrialLicense (payload) {
    return Api().post('issueTrialLicense', payload);
  },
  requestKitUpgrade () {
    return Api().post('issueKitTrial');
  },
  loadActiveLicenses() {
    return Api().get('loadActiveLicenses');
  },
  get() {
    return Api().get('licenses');
  }
}